module.exports = __webpack_public_path__ + "img/medical_supply.b2166faa.svg";